/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Upgrade_BtnInputs */



/**
* | output |
* | --- |
* | "Add now" |
*
* @param {Partner_Manage_Storage_Upgrade_BtnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_upgrade_btn = /** @type {((inputs?: Partner_Manage_Storage_Upgrade_BtnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Upgrade_BtnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jetzt hinzufügen")
	return /** @type {LocalizedString} */ ("Add now")
});